import { render } from "./PrimaryNavigation.vue?vue&type=template&id=1271fd6d"
import script from "./PrimaryNavigation.vue?vue&type=script&lang=ts"
export * from "./PrimaryNavigation.vue?vue&type=script&lang=ts"
script.render = render

export default script